const CLASS_NAMES = {
  menu_item_active: 'menu__item--active',
};

const SELECTORS = {
  zoomable_images: 'img:not(.image--no-zoom)',
  /* menu */
  menuItemId: ['case-studies', 'sneak-peek', 'resume', 'contact'],
  // TODO: refactor
  menu_item: '.menu__item',
  // TODO: refactor
  menu_item_active: `.${CLASS_NAMES.menu_item_active}`,
  videoContainer: '[data-video]',
  videoElement: 'video',
  videoPlayButton: '.video__play-button',
  videoPlayButtonIcon: '.video__play-button__icon',
  videoProgressBarContainer: '[role="progressbar"]',
  videoProgressBarElement: '.video__play-button__progress',
};

export { SELECTORS, CLASS_NAMES };
